import { ReactNode } from 'react';

export interface IAccessCondition {
  checks: boolean[],
  fallback?: ReactNode,
}

interface IUseAccessConditionsOptions {
  accessConditions?: IAccessCondition[],
  defaultFallback?: ReactNode,
}

interface IUseAccessConditionsResult {
  accessConditionsList: IAccessCondition[],
  hasAccessConditions: boolean,
}

export const useAccessConditions = ({
  accessConditions,
  defaultFallback,
}: IUseAccessConditionsOptions): IUseAccessConditionsResult => {
  const accessConditionsList = !accessConditions
    ? []
    : accessConditions.map((condition) => ({
      ...condition,
      fallback: condition.fallback ?? defaultFallback,
    }));

  const hasAccessConditions = accessConditionsList.length > 0;

  return {
    accessConditionsList,
    hasAccessConditions,
  };
};
